import React, {useState} from "react"
import {obervationTypeById} from "../metaDataProcessed"
import {EditObservationPopup} from "./EditObservationPopup";
import {AlternativeButton} from "../widgets/Buttons";
import {formatDate} from "../utils";
import Link from "../widgets/Link";
import {createTimeRule, createTimeRuleForObservations} from "../rules";
import {useApi} from "../ApiSession";
import {alphabetical} from "radash";
import {VisitNotes} from "./VisitNotes";


export const ObservationView = ({dossier, currentRound, healthOverviewDispatch, row}) => {

    const observation_type_id = row.o.o.id

    const observationType = obervationTypeById[observation_type_id]

    return <td
        colSpan={2}
        className={"px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"}
    >
        <div style={{marginLeft: `${row.depth * 2}rem`}}>
            <div style={{cursor: 'pointer'}}>

                    <h3>{row.o.label}</h3>
                    {
                        <ObservationInstancesTable
                            dossier={dossier}
                            row={row}
                            roundObservations={row.o.roundObservations}
                            roundNotes={row.o.roundNotes}
                            observation_type_id={observation_type_id}
                            observationType={observationType}
                            healthOverviewDispatch={healthOverviewDispatch}
                            currentRound={currentRound}
                        />
                    }

            </div>
        </div>
    </td>
}

const ObservationInstancesTable = ({
    dossier,
    observationType,
    observation_type_id, healthOverviewDispatch, roundObservations, currentRound, roundNotes, row
}) => {

    const adatas = observationType.additionalData

    const [editedRoundObservation, setEditedRoundObservation] = useState(null)

    const [editedNewRoundObservation, setEditedNewRoundObservation] = useState(null)

    const api = useApi()

    const renderTableColumnHeaders = () => <>
        <th>Saisie</th>
        {adatas.map(adata =>
            <th className="px-6 py-4" key={`header-${adata.fieldName}`}>
                {adata.label}
            </th>
        )}
    </>

    const renderField = (adata, value) => {
        switch (adata.type) {
            case "date":
            case "dateD":
                return value ? value : "---"
            case "dateF":
            case "dateFF":
                return value ? value : adata.typeRules.renderValue(value)
            case "nombre":
                return value
            case "text":
                return value
            case "choix_multiple_non_ex":
                if(value) {
                    return value.join(", ")
                }
                return  value
            case "choix_multiples":
                return value
            case "choice":
                return value
            case "boolean":
                return value ? "oui": "non"
        }
    }

    const sortKeyFuncCreator = () => {
        const sortAdataForObs = row.o.o.orderByField

        if(!sortAdataForObs) {
            return ""
        }
        const sortFieldName = adatas.find(a => a.key === sortAdataForObs).fieldName
        return observation => `${observation.fields[sortFieldName]}`
    }

    const sortFunc = sortKeyFuncCreator()

    function * genObs() {
        for (const vo of roundObservations) {
            if (!vo.observations) {
                continue
            }

            if(vo.observations.length === 0) {
                continue
            }

            const [firstObs, ...remainingObs] = alphabetical(vo.observations, sortFunc)

            yield {
                round: vo.round,
                observation: firstObs,
                isRoundGroupRow: true,
                rowCount: vo.observations.length
            }

            for(const ro of remainingObs) {
                yield {
                    round: vo.round,
                    observation: ro
                }
            }
        }
    }

    const timeRule = createTimeRule(row.o.o)
    const rule = createTimeRuleForObservations(row.o.o)

    const sortedObs = [...genObs()]

    const obsList = sortedObs.map(vo => vo.observation)

    const validRes = rule(obsList)

    function *genTableRows() {

        let c = 0
        for(const vo of sortedObs) {

            const errorsForVo = validRes.errorMessagesObservations[c]

            yield <tr
                key={`row-${vo.observation.id}`}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                onClick={() => {
                    setEditedRoundObservation(vo)
                }}
            >
                {
                    vo.isRoundGroupRow && <td
                    className="px-6 py-4"
                    key={`adata-visite`}
                    rowSpan={vo.rowCount}
                >
                        <div>{vo.round.visit_label}</div>
                        <div>(visite du {vo.round.visit_date})</div>
                    </td>
                }

                {
                    adatas.map(adata => {

                        const valRes = timeRule(vo.observation.fields, dossier)

                        return <td
                            className="px-6 py-4"
                            key={`adata-${adata.fieldName}-${vo.observation_type_id}-${vo.round.id}`}
                        >
                            {
                                vo.observation ?
                                    renderField(adata, vo.observation.fields[adata.fieldName]) :
                                    "---"
                            }

                            <span className={"ml-2"}>
                                <TimeError
                                    message={errorsForVo && errorsForVo[adata.fieldName] || valRes.errorMessages[adata.key]}
                                />
                            </span>

                        </td>
                    })
                }
                <td>
                    <div>
                        <i>
                        dernière modification {formatDate(new Date(vo.observation.last_update))}
                        </i>
                    </div>
                    <Link caption={"supprimer"} onClick={e => {
                        e.stopPropagation()
                        api.deleteObservation(vo.observation.id).then(res => {
                            healthOverviewDispatch({
                                name: "deleteObservation",
                                observation_round_id: vo.observation.id,
                                observation_type_id: vo.observation.observation_type_id,
                            })
                        })
                    }
                    }/>
                </td>
            </tr>

            c += 1
        }
    }

    const renderTableRows = () => [...genTableRows()]

    const canAdd = observationType.isMultiple || (!observationType.isMultiple && obsList.length === 0)


    const roundHasItem = (roundId) => {
        for(const o of sortedObs) {
            if(o.round.id === roundId) {
                return true
            }
        }
        return false
    }

    return <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        {
            editedRoundObservation &&
            <EditObservationPopup
                title={observationType.name}
                dossier={dossier}
                row={row.o.o}
                observation={editedRoundObservation.observation}
                round={editedRoundObservation.round}
                adatas={adatas}
                onSaveClick={fields => {
                    api.updateObservation(editedRoundObservation.observation.id, fields).then(res => {
                        healthOverviewDispatch({
                            name: "updateObservationFields",
                            observation_round_id: editedRoundObservation.observation.id,
                            observation_type_id: editedRoundObservation.observation.observation_type_id,
                            fields,
                            last_update: res.last_update
                        })
                        setEditedRoundObservation(null)
                    })
                }}
                onCancelClick={() => setEditedRoundObservation(null)}
            />
        }
        {
            editedNewRoundObservation &&
            <EditObservationPopup
                title={observationType.name}
                observation={null}
                row={row.o.o}
                dossier={dossier}
                round={currentRound}
                adatas={adatas}
                onSaveClick={fields => {
                    api.newObservation(currentRound.id, observation_type_id, fields).then(res => {
                        healthOverviewDispatch({
                            name: "newObservation",
                            round: currentRound,
                            observation_type_id,
                            new_id: res.id,
                            fields,
                            last_update: res.last_update
                        })
                        setEditedNewRoundObservation(null)
                    })
                }}
                onCancelClick={() => setEditedNewRoundObservation(null)}
            />
        }
        <div className={"m-4"}>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    {renderTableColumnHeaders()}
                </tr>
                </thead>
                <tbody>
                {renderTableRows()}
                </tbody>
            </table>

            <div className={"mt-4"}></div>

            {
                canAdd &&  <div style={{margin: 10}}>
                    <AlternativeButton
                        caption={`nouvelle entrée`}
                        onClick={() => {

                            const newO = {
                                roundId: currentRound.id,
                                observation_type_id: observation_type_id,
                                fields: {}
                            }

                            setEditedNewRoundObservation(newO)
                        }}
                    />
                </div>
            }

            <div className={"mt-4"}></div>

            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <tbody>
                {
                    roundNotes.filter(
                        // ne pas montrer les notes vides de vieilles saisies
                        roundNote =>
                            roundHasItem(roundNote.round.id) && (
                                currentRound.id === roundNote.round.id ||
                                (roundNote.note && roundNote.note.notes)
                            )
                    ).map(
                        roundNote =>
                            <VisitNotes
                                key={`r-${roundNote.round.id}-${observation_type_id}`}
                                roundNote={roundNote}
                                observation_type_id={observation_type_id}
                                healthOverviewDispatch={healthOverviewDispatch}
                            />
                    )
                }
                </tbody>
            </table>

        </div>
    </div>
}



const TimeError = ({message}) =>
    message && <span className={"text-sm text-red-600 dark:text-red-500"}>{message}</span>
